// AutoGenerated
export class AnketSoruKosulModel {
    secenekModelId!: string | null;
    hedefBolum!: number | null;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}